import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';
import { useNavigate } from 'react-router-dom';

import { gtmDashboardSectionNames } from 'features/views/dashboard/constants';
import { useButtonClickDataLayer } from 'features/views/dashboard/hooks';

export const StatusIndicator = ({ icon, color, value }) => {
	const navigate = useNavigate();

	const pushToClickButtonDataLayer = useButtonClickDataLayer();

	const handleRedirect = useCallback(() => {
		let finalButtonText;
		switch (color) {
			case 'success.main':
				finalButtonText = 'v termínu';
				break;
			case 'warning.main':
				finalButtonText = 'blížící se termín splnění';
				break;
			case 'error.main':
				finalButtonText = 'po termínu';
				break;
		}

		pushToClickButtonDataLayer({
			value: gtmDashboardSectionNames.TASKS,
			button_text: finalButtonText,
		})();
		navigate({
			pathname: '/tasks',
			search: '?quickFilter=tasks',
		});
	}, [navigate, pushToClickButtonDataLayer, color]);

	return (
		<Badge
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			badgeContent={value}
			color="primary"
			overlap="circular"
			showZero
		>
			<Paper
				sx={{
					p: 2,
					borderRadius: 4,
					border: 1,
					boxShadow: '0px 1px 2px 0px #0000001F',
					borderColor: (theme) => theme.palette.divider,
					cursor: 'pointer',
				}}
				onClick={handleRedirect}
			>
				<IconButton sx={{ color, fontSize: 20, p: 0 }} disableRipple onClick={null}>
					{icon}
				</IconButton>
			</Paper>
		</Badge>
	);
};

StatusIndicator.propTypes = {
	color: PropTypes.string,
	icon: PropTypes.node,
	value: PropTypes.number,
};

export default StatusIndicator;
